<!-- App.vue -->
<script setup lang="ts">
// import Navbar from './components/menu/header/index.vue';
import SideBAr from './components/menu/sideBar/index.vue';
// import NoInternetModal from './components/NoInternetModal.vue';
import AiResponse from '../src/components/aiRespone/index.vue';
import GlobalHealthCheck from './components/GlobalHealthCheck.vue';
import NetworkWarning from './components/NetworkWarning.vue';
import { useAuthStore } from '../src/stores/auth';
import { onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router';

const store = useAuthStore();
const route = useRoute();
const isSidebarOpen = ref(false);
const isSidebarIconOnly = ref(false);

// Drawer state
const isDrawerVisible = ref(false);
const drawerHtmlContent = ref('');

// Auth durumuna göre layout kontrolü
const isAuthLayout = computed(() => {
  return store.isAuthenticated && !route.meta.hideNavbar;
});

// Navbar ve Sidebar görünürlük kontrolü
// const showNavbar = computed(() => isAuthLayout.value);
const showSidebar = computed(() => isAuthLayout.value);

// Ana içerik için computed style
const mainContentStyle = computed(() => {
  if (!isAuthLayout.value) {
    return {
      margin: '0',
      padding: '0',
      width: '100%',
      minHeight: '100vh'
    };
  }

  return {
    padding: '0.5rem 0.5rem 0.5rem',
    width: '100%'
  };
});

const handleSidebarResize = (iconOnly: boolean) => {
  isSidebarIconOnly.value = iconOnly;
};

const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};

// Load HTML content and show drawer
const openDrawerWithHtml = async (url: string) => {
  try {
    const response = await fetch(url);
    if (response.ok) {
      drawerHtmlContent.value = await response.text();
      isDrawerVisible.value = true;
    } else {
      console.error('HTML içeriği alınamadı');
    }
  } catch (error) {
    console.error('HTML yükleme hatası:', error);
  }
};

// Expose drawer methods globally
const exposeDrawerMethods = () => {
  if (typeof window !== 'undefined') {
    (window as any).openRightDrawer = openDrawerWithHtml;
  }
};

onMounted(() => {
  store.checkAuth();
  exposeDrawerMethods();
});
</script>

<template>
  <!-- Global Health Check Component -->
  <GlobalHealthCheck />

  <!-- Network monitoring bileşeni - otomatik çalışır -->
  <NetworkWarning />
  <!-- İki farklı layout yapısı -->
  <div v-if="isAuthLayout" class="app-shell">
    <!-- Authenticated Layout -->

    <!-- <Navbar
      v-if="showNavbar"
      @toggleMenu="toggleSidebar"
      class="app-utility-bar"
    /> -->

    <div class="app-layout">
      <SideBAr
        v-if="showSidebar"
        :isOpen="isSidebarOpen"
        @toggleMenu="toggleSidebar"
        @sidebarResize="handleSidebarResize"
      />

      <main class="app-main transition-all duration-300" :style="mainContentStyle">
        <router-view></router-view>
      </main>
    </div>
  </div>

  <!-- Non-Authenticated Layout -->
  <div v-else class="w-full min-h-screen bg-[var(--app-bg)]">
    <main :style="mainContentStyle">
      <router-view></router-view>
    </main>
  </div>

  <!-- No Internet Modal her durumda görünür -->
  <!-- <NoInternetModal /> -->

  <!-- Right Side Drawer Component -->
  <AiResponse v-model:visible="isDrawerVisible" :htmlContent="drawerHtmlContent" />
</template>

<style scoped>
.app-shell {
  position: relative;
  height: 100vh;
  background: var(--app-bg);
  color: var(--app-text);
  overflow: hidden;
}

.app-shell::before,
.app-shell::after {
  content: '';
  position: absolute;
  pointer-events: none;
  z-index: 0;
}





.app-main {
  position: relative;
  z-index: 1;
  height: 100vh;
  overflow-y: auto;

}

.app-layout {
  position: relative;
  z-index: 1;
  display: flex;
  height: 100vh;
}

.app-layout > :first-child {
  flex-shrink: 0;
}

.app-utility-bar {
  z-index: 40;
}

@media (max-width: 1024px) {
  .app-utility-bar {
    top: 0.75rem;
    right: 1rem;
  }
}

@media (max-width: 640px) {
  .app-utility-bar {
    right: 0.75rem;
  }
}
</style>
